require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/fn/array/from.js
// module id = 201
// module chunks = 1